import { useState, useEffect } from 'react';
import { styles } from './styles';
import BaseLayout from '../../components/layouts/BaseLayout';
import LeftColumn from '../../components/misc/LeftColumn/LeftColumn';
import RightColumn from '../../components/misc/RightColumn/RightColumn';
import SearchBar from '../../components/misc/SearchBar/SearchBar';
import NewsItem from './components/NewsItem/NewsItem';
import SelectedItemContainer from './components/SelectedItemContainer/SelectedItemContainer';
import { INewsItemType } from '../../types';
import { useDispatch } from 'react-redux';
import { getFundMarketNewsList } from '../../utils/api';
import { setFundMarketInitialList } from '../../features/fundMarketNews/fundMarketNewsSlice';
import { filterNewsItems } from '../../utils/utils';
import { useSelectFundMarketNewsList } from '../../features/fundMarketNews/hooks/useSelectFundMarketNewsList';
import useLanguage from '../../utils/customHook';
import { useTranslation } from 'react-i18next';
import Header from './Header/Header';
import EmptySearchResult from '../../components/misc/EmptySearchResult/EmptySearchResult';

export default function FundMarketNews() {
  const [newsElement, setNewsElement] = useState<INewsItemType>();

  const { lang } = useLanguage();
  const dispatch = useDispatch();

  const [searchTerm, setSearchTerm] = useState<string | null>(null);
  const fundMarketNewsData = useSelectFundMarketNewsList();
  const [newsList, setNewsList] = useState(fundMarketNewsData);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getFundMarketNewsList().then((listElements) => {
      dispatch(setFundMarketInitialList(listElements));
      setLoading(false);
    });
  }, [dispatch]);

  useEffect(() => {
    setNewsList(fundMarketNewsData);
    setNewsElement(fundMarketNewsData[0]);
  }, [fundMarketNewsData]);

  useEffect(() => {
    if (searchTerm) {
      const updatedListElements = filterNewsItems(
        searchTerm,
        fundMarketNewsData,
        lang
      );
      setNewsElement(updatedListElements[0]);
      return setNewsList(updatedListElements);
    } else {
      setNewsElement(fundMarketNewsData[0]);
      return setNewsList(fundMarketNewsData);
    }
    // eslint-disable-next-line
  }, [searchTerm]);

  const handleSearch = (searchTerm: string) => {
    setSearchTerm(searchTerm);
  };
  return (
    <BaseLayout>
      <styles.MainContainer>
        <LeftColumn>
          <Header />
          <styles.NewsContainer>
            <SearchBar searchTerm={searchTerm || ''} onChange={handleSearch} />
            <styles.NewsWrapper>
              <NewsItemsComponent
                loading={loading}
                newsList={newsList}
                setNewsElement={setNewsElement}
              />
            </styles.NewsWrapper>
          </styles.NewsContainer>
        </LeftColumn>
        <RightColumn>
          <SelectedItemContainer newsItemData={newsElement} />
        </RightColumn>
      </styles.MainContainer>
    </BaseLayout>
  );
}

type NewsItemComponentProps = {
  loading: boolean;
  newsList: INewsItemType[];
  setNewsElement: React.Dispatch<
    React.SetStateAction<INewsItemType | undefined>
  >;
};

function NewsItemsComponent({
  loading,
  newsList,
  setNewsElement
}: NewsItemComponentProps) {
  const { t } = useTranslation();

  const handleOnClick = (data: INewsItemType) => {
    setNewsElement(data);
  };

  if (loading && newsList.length === 0) return <span>Loading...</span>;

  if (newsList.length === 0 && !loading)
    return (
      <EmptySearchResult emptySearchText={t('fund.news.empty.search.result')} />
    );

  return (
    <>
      {newsList.map((data) => (
        <NewsItem key={data.id} newsItemData={data} onClick={handleOnClick} />
      ))}
    </>
  );
}
